import { render, staticRenderFns } from "./ClientMandateInfo.vue?vue&type=template&id=08681b89"
import script from "./ClientMandateInfo.vue?vue&type=script&lang=js"
export * from "./ClientMandateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports